module.exports = __webpack_public_path__ + "f3b742d90d8cfc79b258e19993474e99.svg";